export const Facility = (json: IFacility): IFacilityModel => ({
	id: json.id,
	name: json.name,
	identifier: json.identifier ?? json.id,
	isVirtual: json.is_virtual ?? false,
})
